import general from "./general";
import { pathAnimate } from "./functions";

const teams = {
    init: function () {
        document.addEventListener("DOMContentLoaded", () => {
            teams.teamsSlider();
            teams.teamsFavoriteSlider();
            pathAnimate();
        });
    },
    teamsSlider: function () {
        const teams_self__img_list = $(".teams-self__img-list");
        if (teams_self__img_list.length === 0) return;

        teams_self__img_list.flickity({
            cellAlign: "left",
            friction: 0.3,
            prevNextButtons: false,
            pageDots: false,
            watchCSS: true,
        });
    },
    teamsFavoriteSlider: function () {
        const teams_favorite__grid = $(".teams-favorite__grid");
        if (teams_favorite__grid.length === 0) return;

        teams_favorite__grid.flickity({
            cellAlign: "left",
            friction: 0.3,
            prevNextButtons: false,
            pageDots: false,
            watchCSS: true,
        });
    },
};

general.init();
teams.init();

export default teams;
